import * as Sentry from '@sentry/vue'
import { computed, ref } from '@vue/composition-api'
import { capitalize } from 'lodash'

import store from './store'

const standardErrorMessage = 'Error: There was an error while submitting your request'

export const alertHandler = _ => {
  // reactive properties
  const localAlert = ref('')

  // computed properties
  const isLoggedIn = computed(_ => store.getters.isLoggedIn)

  // methods
  const displayDetailedAlert = _ => {
    let calculatedMessage

    if (localAlert.value.type === 'error') {
      const errors = findErrorObject()
      const errorMessage = errors
        ? getDetailedError(errors)
        : localAlert.value.message

      calculatedMessage = errorMessage || standardErrorMessage
    } else if (['info', 'success', 'warning'].includes(localAlert.value.type)) {
      calculatedMessage = localAlert.value.message ? localAlert.value.message : 'Success'
    }

    showAlert(localAlert.value.type, calculatedMessage, localAlert.value.options)
  }

  const showAlert = (type, message, options = {}) => {
    store.commit('setAlert', {
      isShowing: true,
      message: message,
      options: options,
      type: type,
    })

    if (options.timeout !== null) showAlertWithTimeout(type, message, options)
  }

  const showAlertWithTimeout = (options = {}) => {
    setTimeout(_ => {
      store.commit('setAlert', null)
    }, options.timeout || 5000)
  }

  const getDetailedError = errors => {
    const errorKeys = Object.keys(errors)

    return errorKeys.
      map(k => {
        return capitalize(k.replace(/_/g, ' ')) + ': ' + errors[k]
      }).
      join(', ')
  }

  const findErrorObject = _ => {
    if (localAlert?.value?.errorObject instanceof Error) {
      Sentry.captureException(localAlert.value.errorObject)
      return { message: localAlert.value.errorObject.message }
    }

    if (localAlert?.value?.errorObject?.response?.data?.json) return localAlert.value.errorObject.response.data.json
    else if (localAlert?.value?.errorObject?.data?.errors) return localAlert.value.errorObject.data.errors
    else return null
  }

  const displayAlert = (type, message, errorObject, options = {}) => {
    localAlert.value = {
      type: type,
      message: message,
      options: options,
    }

    if (type === 'error' && errorObject) localAlert.value.errorObject = errorObject

    if (isLoggedIn.value) displayDetailedAlert()
    else showAlert(localAlert.value.type, localAlert.value.message)
  }

  return {
    displayAlert,
  }
}
